import api from '@/services/api.js'

export default{
    getobject(key){
        let json_str = window.localStorage[key];
        if (json_str!==undefined){
            return JSON.parse(json_str);
        }else{
            return null;
        }
    },
    saveobject(key, obj){
        window.localStorage[key] = JSON.stringify(obj);
    },
    clearobject(key){
        window.localStorage.removeItem(key);
    },
    getCurrentToken(){
        let profile = this.getobject('me');
        return profile.token;
    },
    post(path, data, on_success, on_error){
        let token = this.getCurrentToken();
        api.api_post(path, token, data, on_success, on_error);
    },
    get(path, on_success, on_error){
        let token = this.getCurrentToken();
        api.api_get(path, token, on_success, on_error);
    }
}


// WEBPACK FOOTER //
// ./src/services/service.js